export default __webpack_public_path__ + "fonts/solutions-1.svg";